import React, { useMemo } from 'react';
import DividerWithText from '../../../../../../components/DividerWithText';
import { useTranslation } from 'react-i18next';
import ButtonAction from '../../../../../../components/buttons/ButtonAction';
import {RenewIcon} from '../../../../../../components/buttons/IconButtons';
import ColorRow from "./SubComponents/ColorRow";
import ColorHead from "./SubComponents/ColorHead";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 * @param item
 * @param onChange
 *
 * @param resetToDefaultPallet
 */

const PayrollColor = ({ item, onChange, resetToDefaultPallet }) => {
    const { t } = useTranslation();

    const rows = useMemo(
        () => [
            { labelKey: "in_time", bgName: "inTime", txtName: "inTimeTxt", idBase: "in_time" },
            { labelKey: "tolerance_time", bgName: "toleranceTime", txtName: "toleranceTimeTxt", idBase: "tolerance_time" },
            { labelKey: "after_hours", bgName: "afterHours", txtName: "afterHoursTxt", idBase: "after_hours" },
            { labelKey: "absence", bgName: "absent", txtName: "absentTxt", idBase: "absence" },
            { labelKey: "no_department", bgName: "noDepartment", txtName: "noDepartmentTxt", idBase: "no_department" },
            { labelKey: "special_permission", bgName: "specialPermission", txtName: "specialPermissionTxt", idBase: "special_permission" },
            { labelKey: "off_schedule_departure", bgName: "offScheduleDeparture", txtName: "offScheduleDepartureTxt", idBase: "off_schedule_departure" },
            { labelKey: "off_schedule_arrival", bgName: "offScheduleArrival", txtName: "offScheduleArrivalTxt", idBase: "off_schedule_arrival" },
            { labelKey: "vacations", bgName: "onVacations", txtName: "onVacationsTxt", idBase: "vacations" },
        ],
        []
    );

    return (
        <>
            <div className="col-12">
                <DividerWithText spacing="my-4" title={t("color_palette")} />
            </div>

            <div className="pb-4">
                <ButtonAction
                    id='btn_pc_reset_to_default'
                    name='reset_to_default'
                    className={'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        resetToDefaultPallet();
                    }}
                    Icon={RenewIcon}
                />
            </div>

            <div className="d-flex flex-column gap-2">
                <ColorHead />
                {rows.map(r => (
                    <ColorRow
                        key={r.bgName}
                        labelKey={r.labelKey}
                        bgName={r.bgName}
                        txtName={r.txtName}
                        idBase={r.idBase}
                        item={item}
                        onChange={onChange}
                    />
                ))}
            </div>
        </>
    );
};

export default PayrollColor;
